import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import CreateTransactionForm from '../../components/CreateTransactionForm';
import { useNavigate } from 'react-router-dom';
import { getUserFromStorage } from '../../utils/auth';

const AdminCreateTransactionPage = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = getUserFromStorage();
    if (storedUser?.role === 'admin') {
      setUser(storedUser);
    } else {
      navigate('/login'); // ✅ redirect if not admin
    }
  }, [navigate]);

  if (!user) return null;

  return (
    <DashboardLayout role="admin">
     <CreateTransactionForm user={user} />
    </DashboardLayout>
  );
};


export default AdminCreateTransactionPage;
